$shm_hitalama_project_codex $shm_codex_app
	sessions_page_visible false
	width? 432
	width_px \432px
	project_id \
	Completion_sound $mol_check_box
		title \Звук
		hint <= completion_sound_hint \Отключить звук завершения
		checked? <=> completion_sound_enabled? true
	style *
		^
		width <= width_px
		flexBasis <= width_px
		flexGrow 0
		flexShrink 0
		minWidth \24rem
